import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useDomContentRect } from '@fabric-app/hooks/useDomContentRect';
import React__default from 'react';
import { styled } from 'styled-components';

const HEIGHT_DIFF_THRESHOLD = 2;
const TruncatorV2 = ({ parentRef, children }) => {
  const [parentRect] = useDomContentRect(parentRef);
  const testRef = React__default.useRef(null);
  const [testRect] = useDomContentRect(testRef);
  const parentRectHeight = Math.floor(parentRect?.height || 0);
  const [height, setHeight] = React__default.useState(0);
  React__default.useEffect(() => {
    if (Math.abs(height - parentRectHeight) > HEIGHT_DIFF_THRESHOLD) {
      setHeight(parentRectHeight);
    }
  }, [
    parentRectHeight,
    height
  ]);
  const linesCount = Math.floor(height / (testRect?.height || 16));
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx(TruncatedText, {
        lines: linesCount,
        children
      }),
      /* @__PURE__ */ jsx(TestTextToCheckLineHeight, {
        ref: testRef,
        children: "p"
      })
    ]
  });
};
const TestTextToCheckLineHeight = styled.div.withConfig({
  displayName: "TruncatorV2__TestTextToCheckLineHeight",
  componentId: "sc-e499d9ef-0"
})([
  `position:absolute;opacity:0;pointer-events:none;`
]);
const TruncatedText = styled.div.withConfig({
  displayName: "TruncatorV2__TruncatedText",
  componentId: "sc-e499d9ef-1"
})([
  `overflow:hidden;text-overflow:ellipsis;white-space:initial;display:-webkit-box;-webkit-line-clamp:`,
  `;-webkit-box-orient:vertical;word-break:break-word;`
], (p) => p.lines);

export { TruncatorV2 };
//# sourceMappingURL=TruncatorV2.js.map
